import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import { IBonusDetailsItem } from '../types';

type GetHeaderCellsCreateType = {
    style: Record<string, string>;
    translate: ITranslateMethod;
}

export const getHeaderCellsCreator = ({ style, translate }: GetHeaderCellsCreateType) => (item: IBonusDetailsItem) => {
    const { name = '', balance: { amount = '' } } = item;

    return [
        {
            id: 0,
            content: name,
            className: 'accordionHeaderSmallDetails'
        },
        {
            id: 1,
            content: `${amount} ${translate('spins')}`,
            className: `${style.amount} accordionHeaderSmallDetails`
        }
    ];
};
